module.exports = __webpack_public_path__ + "assets/getCoordinate.b8f7f816.svg";